const INITIAL_STATE = {
  isDrawerCollapsed: true,
  data: {
    tabId: undefined
  }
};

export default function sideDrawerReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@SIDEDRAWER_OPEN':
      return {
        ...state,
        isDrawerCollapsed: false,
        data: action.payload
      };
    case '@SIDEDRAWER_CLOSE':
      return {
        ...state,
        isDrawerCollapsed: true,
        data: {
          tabId: undefined
        }
      };
    case '@SIDEDRAWER_TOGGLE':
      return {
        ...state,
        isDrawerCollapsed: !state.isDrawerCollapsed
      };
    // Essa função notifica o componente `DynamicLayoutModal` de que ele deve reabrir o modal ou a sidebar.
    // Não tem relação com a mudança modal | sidebar -> sidedrawer, mas sim o caminho contrário.
    case '@CHANGE_PROTOCOL_CREATION_LAYOUT':
      return {
        ...INITIAL_STATE,
        isDrawerCollapsed: true,
        isToCloseExtraModal: true,
        data: {
          ...INITIAL_STATE.data,
          tabId: 0
        }
      };

    // criar um novo state pra fechar modal
    case '@CLOSE_EXTRA_PROTOCOL_MODAL':
      return {
        ...state,
        isToCloseExtraModal: true
      };

    case '@NOT_CLOSE_EXTRA_PROTOCOL_MODAL':
      return {
        ...state,
        isToCloseExtraModal: false
      };
    default:
      return state;
  }
}
